module.exports = __webpack_public_path__ + "src/assets/img/map-marker.0d5b3748.svg";